module.exports = __webpack_public_path__ + "static/media/moore_is_better_july_2020_header.79f01125.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/images/moore_is_better_july_2020_header.png
// module id = 23
// module chunks = 0